(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["easy-shop-explorer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const FAMILY_HASH_PREFIX = 'family-';

    const getRequestedFamilyKey = hash => {
      const params = new URLSearchParams(window.location.search);
      const queryFamily = (params.get('family') || '').trim().toLowerCase();

      if (queryFamily) {
        return queryFamily;
      }

      const normalized = (hash || window.location.hash || '').replace(/^#/, '').trim().toLowerCase();

      if (!normalized) {
        return '';
      }

      if (normalized.startsWith(FAMILY_HASH_PREFIX)) {
        return normalized.slice(FAMILY_HASH_PREFIX.length);
      }

      return normalized;
    };

    const syncFamilySections = root => {
      const familySections = Array.from(root.querySelectorAll('.easy-shop-explorer[data-family-key]'));

      if (familySections.length < 2) {
        return;
      }

      const activeFamilyKey = getRequestedFamilyKey();
      const activeSection = familySections.find(section => section.dataset.familyKey === activeFamilyKey);
      const fallbackSection = familySections.find(section => section.dataset.hideByDefault !== 'true');

      if (!activeSection && !fallbackSection) {
        return;
      }

      const visibleSection = activeSection || fallbackSection;

      familySections.forEach(section => {
        section.hidden = section !== visibleSection;
      });
    };

    const initialize = section => {
      if (!section || section.dataset.easyShopExplorerReady === 'true') {
        return;
      }

      const tabs = Array.from(section.querySelectorAll('[data-group-target]'));
      const panels = Array.from(section.querySelectorAll('[data-group-panel]'));

      if (!tabs.length || !panels.length) {
        return;
      }

      section.dataset.easyShopExplorerReady = 'true';

      const applyState = groupId => {
        section.dataset.activeGroup = groupId;

        tabs.forEach(tab => {
          const isActive = tab.dataset.groupTarget === groupId;
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(panel => {
          panel.hidden = panel.dataset.groupPanel !== groupId;
        });
      };

      const setActive = groupId => {
        if (section.dataset.activeGroup === groupId) {
          return;
        }

        if (document.startViewTransition) {
          document.startViewTransition(() => applyState(groupId));
        } else {
          applyState(groupId);
        }
      };

      tabs.forEach(tab => {
        tab.addEventListener('click', () => setActive(tab.dataset.groupTarget));
      });

      applyState(section.dataset.activeGroup || tabs[0].dataset.groupTarget);
    };

    const boot = root => {
      root.querySelectorAll('.easy-shop-explorer').forEach(initialize);
      syncFamilySections(root);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot(document), { once: true });
    } else {
      boot(document);
    }

    document.addEventListener('shopify:section:load', event => {
      boot(event.target);
    });

    window.addEventListener('hashchange', () => {
      syncFamilySections(document);
    });

    window.addEventListener('popstate', () => {
      syncFamilySections(document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
